export default __webpack_public_path__ + "static/media/marker-22.ad25dbad.jpg";